import upload from './file-upload';

export function uploadFileAttachments(formData) {
  return upload('email_attachments', formData);
}
